// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.5.0",
    "short": "3f2d4ed",
    "branch": "Detached: 3f2d4ed13dfb086827a9ccf301eba6018cbd82da",
    "date": "2026-9-5"
};
/* eslint:enable */
